import React, { PropTypes } from 'react';
import cx from './ReviewAvgRating.scss';

import StarRating from 'components/StarRating';
import connectToStores from 'decorators/connectToStores';
import withStyles from 'decorators/withStyles';

@withStyles(cx)
@connectToStores({
	ratings: ({ state }, props) => ({
		rating: props.rating ? props.rating : Number(state.ratings[props.coachId].rating),
	}),
})
export default class ReviewAvgRating extends React.Component {
	static propTypes = {
		rating: PropTypes.number.isRequired,
		coachId: PropTypes.number.isRequired,
		showLabel: PropTypes.bool,
	};

    static defaultProps = {
        showLabel: true,
    };

	render() {
		const { rating } = this.props;
        const { showLabel } = this.props;

		if (showLabel) {
            return (
                <div>
                    <StarRating value={rating} />
                    <span className={cx('label')}>{__('rating')} {rating}</span>
                </div>
            );
        } else {
            return (
                <div>
                    <StarRating value={rating} />
                </div>
            );
        }
	}
}



// WEBPACK FOOTER //
// ./src/react/elements/ReviewAvgRating/ReviewAvgRating.js